<h2 mat-dialog-title class="ppd-title">
  <mat-icon class="ppd-title-icon">policy</mat-icon>
  {{ 'policyPicker.title' | transloco }}
</h2>

<mat-dialog-content class="ppd-content">
  <!-- Search -->
  @if (!isEmpty()) {
    <mat-form-field appearance="outline" class="ppd-search">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput
             [formControl]="searchCtrl"
             [placeholder]="'policyPicker.searchPlaceholder' | transloco" />
    </mat-form-field>
  }

  <!-- Policy List -->
  @if (isEmpty()) {
    <div class="ppd-empty">
      <mat-icon class="ppd-empty-icon">inbox</mat-icon>
      <p class="ppd-empty-text">{{ 'policyPicker.emptyState' | transloco }}</p>
    </div>
  } @else {
    <div class="ppd-list">
      @for (policy of filteredPolicies(); track policy.id) {
        <button class="ppd-card"
                [class.ppd-card--selected]="selectedId() === policy.id"
                (click)="select(policy)">
          <div class="ppd-card-header">
            <span class="ppd-card-name">{{ getPolicyName(policy) }}</span>
            <span class="ppd-card-count">
              {{ (policy.constraints?.length ?? 0) }}
              {{ 'policyPicker.constraintCount' | transloco }}
            </span>
          </div>
          @if (getPolicyDescription(policy); as desc) {
            <p class="ppd-card-desc">{{ desc }}</p>
          }
          @if (getConstraintSummary(policy); as summary) {
            <p class="ppd-card-summary">{{ summary }}</p>
          }
        </button>
      } @empty {
        <p class="ppd-no-results">{{ 'policyPicker.noResults' | transloco }}</p>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">
    {{ 'policyPicker.cancel' | transloco }}
  </button>
</mat-dialog-actions>
